

import React, { useEffect, useState } from "react";

const WhatsAppButton: React.FC = () => {
  const [showButton, setShowButton] = useState(false);
  const [hideText, setHideText] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setShowButton(scrollY > 100);
      setHideText(scrollY > 1000); // Desaparece suavemente si pasás 400px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const whatsappLink = "https://wa.me/5491153873721";

  return (
    <div className={`whatsapp-container ${showButton ? "show" : ""}`}>
      <div className={`whatsapp-label ${hideText ? "fade-out" : "fade-in"}`}>
        ¿Necesitás ayuda?
      </div>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-icon"
        aria-label="WhatsApp"
      >
        <i className="bi bi-whatsapp"></i>
      </a>
    </div>
  );
};

export default WhatsAppButton;